import { useTranslation } from 'hooks';
import Link from 'components/ui/link';
import './policyLinks.scss';

const PolicyLinks: React.FC = () => {
  const getTranslate = useTranslation();

  return (
    <div className='policy-links'>
      <Link url='/cookie-policy' target='_blank' className='policy-links__item'>
        {getTranslate('common.cookies.link')}
      </Link>
      <Link
        url='/privacy-policy'
        target='_blank'
        className='policy-links__item'>
        {getTranslate('common.privacyPolicy.link')}
      </Link>
    </div>
  );
};

export default PolicyLinks;
